// extracted by mini-css-extract-plugin
export default {"Drawer":"Drawer_Drawer__Il9VE","Bottom":"Drawer_Bottom__4oSkz","Right":"Drawer_Right__9pqtT"};